import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useProfile } from '../../../hooks/useProfile'

export const useAdminGuard = () => {
  const { data: profile, isLoading } = useProfile()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !profile?.is_super_admin) {
      navigate('/calendar', { replace: true })
    }
  }, [isLoading, profile, navigate])

  return { isLoading, isSuperAdmin: profile?.is_super_admin ?? false }
}
